let w = window as any;
let numeral = require('numeral');
let S = require('string');

export interface IHash<T> {
	[key: string]: T
}

let isTouch: boolean = null;

w.NP = {
	localStorage: localStorage,
	sessionStorage: sessionStorage,
	IsEdge: navigator.userAgent.indexOf(' Edge/') > -1,
	IsFF: navigator.userAgent.indexOf(' Firefox/') > -1,
	IsSafari: navigator.userAgent.indexOf("Mac") > -1 && navigator.userAgent.indexOf("Safari/") > -1 && navigator.userAgent.indexOf("Chrome/") === -1 && navigator.userAgent.indexOf(' Edge/') == -1,
	IsMac: navigator.userAgent.indexOf("Mac") > -1,
	IsTouch: !!('ontouchstart' in window) && navigator.userAgent.indexOf('Windows NT') == -1,
	IsChrome: navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf(' Edge/') == -1,
	PageId: new Date().getTime(),
	FontFamily: "Open Sans",
	PanelSettingsWidth: 320,
	TopAppBarHeight: 64,
	CreateButtonNodeHeight: 73,
	getDefaultNumberFormat: () =>
	{
		return {
			f: "0,0.[00]",
			m: '{{Value}}'
		} as NumberFormat;
	},
	delay: (ms: number) =>
	{
		return new Promise((resolve) =>
		{
			setTimeout(resolve, ms)
		});
	},
	ImagePath: "",
	ScriptPath: "",
	ClientRevision: '{Version}',
	Config: {
		ExportURL: "",
		CHECK_STATUS_TIME: 0,
		CHECK_ANYWAY_STATUS_TIME: 0,
		Version: "1.0",
		AppName: 'NP',
		HelpEmail: '',
		Origin: '',
		ImagePath: "../img/",
		ScriptPath: "../js/",
		CountryFlagPath: ''
	},
	isTouchDevice: function ()
	{

		if (navigator.userAgent.toLowerCase().indexOf('ipad') > -1)
			return true;

		if (isTouch != null)
			return isTouch;

		//@ts-ignore
		if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch)
		{
			return isTouch = true;
		}

		let prefixes = ' -webkit- -moz- -o- -ms- '.split(' '),
			 mq = function (query: string)
			 {
				 return window.matchMedia(query).matches;
			 };
		let query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
		return isTouch = !!mq(query);
	}
};

let NP = w.NP;

let cnode = document.querySelector('script[src*="app.js"]');
if (cnode)
{
	let verP = cnode.getAttribute('src').split("?");
	NP.ClientRevision = verP.length > 1 ? verP[1].split("=")[1] : "{Version}";
}

NP.parseHTML = function (html: string)
{
	let elem = NP._nodesCache[html];
	if (!elem)
	{
		elem = document.createElement('span');
		elem._tempNode = true;
		elem.innerHTML = html;
		NP._nodesCache[html] = elem.cloneNode(true);
	}
	else
		elem = elem.cloneNode(true);
	elem = elem.firstChild;
	if (elem.parentNode)
		elem.parentNode.removeChild(elem); //span остается родителем
	return elem;
};

NP.findByPropName = function (list: Array<any>, propName: string, value: object)
{
	let index = NP.findIndex(list, propName, value);
	if (index > -1)
		return list[index];
};

NP.findIndex = function (list: Array<any>, propName: string, value: object)
{
	if (list)
		for (var i = 0; i < list.length; i++)
		{
			if (list[i][propName] == value)
				return i;
		}
	return -1;
};

export interface NumberFormat {
	f: string,
	m: string;
	c?: number;
}


NP.applyFormat = function (value: number, formatObj: NumberFormat, coef: number)
{
	if (!formatObj)
		return value;
	if (NP.isString(formatObj)) //старый формат
		throw new Error('Old number format');
	else
	{
		let textValue = NP.getValueWithSuffix(value, formatObj.f, coef);
		return S(formatObj.m).template({Value: textValue}).s;
	}
};

NP._powerIndexes = [1, 1000, 1000000, 1000000000, 1000000000000, 1000000000000000];

NP.isVerySmallValue = function (value: number)
{
	return Math.abs(value).toFixed(5) == '0.00000';
};

NP.getValueWithSuffix = function (value: number, format: any, coef: number)
{
	if (value == null)
		return "";

	let suffix = "";

	if (!format)
		format = NP.getDefaultNumberFormat().f;

	let suffixes = [
		NP.RM.getString("ThousandsPrefix"),
		NP.RM.getString("MillionsPrefix"),
		NP.RM.getString("BillionsPrefix"),
		NP.RM.getString("TrillionsPrefix"),
		NP.RM.getString("QuadrillionsPrefix")
	];

	if (format.indexOf("%") > -1)
	{
		format = format.replace(/%+/g, "%");
		value *= 100;
	}


	if (coef && NP._powerIndexes.indexOf(coef) > -1)
	{
		let index = NP._powerIndexes.indexOf(coef);
		suffix = suffixes[index - 1] || "";
		value = value / NP._powerIndexes[index];

		if (NP.isVerySmallValue(value))
			value = 0;  //слишком маленькое значение

		if (format.indexOf("%") > -1)
		{
			value /= 100;
			return numeral(value).format(format).replace("%", "") + suffix + "%";
		}
		else
			return numeral(value).format(format) + suffix;
	}
	else
	{
		if (NP.isVerySmallValue(value))
			value = 0;  //слишком маленькое значение

		if (Math.abs(value) < 1000)
		{
			if (format.indexOf("%") > -1)
				value /= 100;
			return numeral(value).format(format);
		}

		let power = 5;
		for (let i = 0; i < NP._powerIndexes.length; i++)
		{
			if (Math.abs(value / NP._powerIndexes[i]) < 1000)
			{
				power = i;
				break;
			}
		}
		value /= Math.pow(1000, power);
		if (power)
			suffix = suffixes[power - 1] || "";

		if (format.indexOf("%") > -1)
			value /= 100;
		if (!format)
			return value + suffix;

		if (format.indexOf("%") > -1)
			return numeral(value).format(format).replace("%", "") + suffix + "%";
		else
			return numeral(value).format(format) + suffix;
	}
};


NP.getQueryParam = function (key: string, queryString: string = window.location.href.split("?")[1])
{
	if (!queryString)
		return null;
	let urlParams = new URLSearchParams(queryString);
	return urlParams.get(key);
};

NP.loadTo = function (url: string, newWindow?: boolean)
{
	try
	{
		if (newWindow)
			window.open(NP.Config.Origin + url);
		else
			window.location.href = NP.Config.Origin + url;
	} catch (e)
	{
		console.log(e);
	}
};

NP.isCtrlKey = function (evt: KeyboardEvent)
{
	return evt.ctrlKey || NP.IsMac && evt.metaKey;
};

NP.min = function (arr: Array<number>)
{
	return Math.min.apply(Math, arr);
};

NP.max = function (arr: Array<any>)
{
	return Math.max.apply(Math, arr);
};


NP.removeFromArray = function (arr: Array<any>, item: any)
{
	if (arr)
		return NP.removeFromArrayByIndex(arr, arr.indexOf(item));
};

NP.removeFromArrayByIndex = function (arr: Array<any>, index: number)
{
	if (index > -1 && index < arr.length)
	{
		arr.splice(index, 1);
		return true;
	}
	return false;
};

NP.insertToArray = function (arr: Array<any>, item: object, index?: number)
{
	if (index > -1 && index <= arr.length)
		arr.splice(index, 0, item);
	else
		arr.push(item);
};


NP.isNumber = function (v: any, tryParse?: boolean)
{
	if (tryParse)
		return typeof parseFloat(v) === 'number' && isFinite(parseFloat(v));
	return typeof v === 'number' && isFinite(v);
};

NP.isString = function (v: object)
{
	return typeof v === 'string';
};

NP.isObject = function (v: object)
{
	return !!v && Object.prototype.toString.call(v) === '[object Object]';
};

NP.isDefined = function (v: object)
{
	return typeof v !== 'undefined';
};

NP.isEmail = function (v: string)
{
	if (!v)
		return false;
	let email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Zа-яА-Я\-0-9]+\.)+[a-zA-Zа-яА-Я]{2,}))$/;
	return email.test(v.trim());
};



NP.toArray = function (obj: object)
{
	return !(NP.isDefined(obj) && obj !== null) || Array.isArray(obj) ? obj : [obj];
};


NP.sumArray = function (arr: Array<number>)
{
	var ret = 0;
	for (let v of arr)
		ret += v;
	return ret;
};

NP.median = function (values: Array<number>)
{
	values.sort((a, b) => a - b);

	let half = Math.floor(values.length / 2);

	if (values.length % 2)
		return values[half];
	else
		return (values[half - 1] + values[half]) / 2.0;
};


NP.find = function (arr: Array<number>, condFunc: Function)
{
	for (let item of arr)
	{
		if (condFunc(item))
			return item;
	}
};

NP.unionArrays = function (arr: Array<any>)
{
	let res = <any>[];
	for (let itemArr of arr)
	{
		if (itemArr && itemArr.length)
			res = res.concat(itemArr);
	}
	return res;
};


NP._nodesCache = {};

NP.parseHTML = function (html: string)
{
	let elem = NP._nodesCache[html];
	if (!elem)
	{
		elem = document.createElement('span');
		elem._tempNode = true;
		elem.innerHTML = html;
		NP._nodesCache[html] = elem.cloneNode(true);
	}
	else
		elem = elem.cloneNode(true);
	elem = elem.firstChild;
	if (elem.parentNode)
		elem.parentNode.removeChild(elem); //span остается родителем
	return elem;
};

NP.parseHTMLC = function (html: string)
{
	let elem = <any>document.createElement('span');
	elem._tempNode = true;
	elem.innerHTML = html;

	elem = elem.firstChild;
	if (elem.parentNode)
		elem.parentNode.removeChild(elem); //span остается родителем
	return elem;
};




NP.getCssStyle = function (node: HTMLElement, prop: string, toNumber?: boolean)
{
	if (!node || !node.style)
		return '';
	if (prop.match(/[A-Z]/))
		prop = prop.replace(/([A-Z])/g, "-$1").toLowerCase();

	let v = node.style[<any>prop];
	let value = (v && v !== "inherit") ? v : document.defaultView.getComputedStyle(node, "").getPropertyValue(prop);
	if (value != undefined)
	{
		if (toNumber)
		{
			let res = parseFloat(value);
			if (isNaN(res))
				return 0;
			else
				return res;
		}
		else
			return value;
	}
	return '';
};

/**
 * @Deprecated
 * @param node
 * @param value
 */
NP.addCssClass = function (node: HTMLElement, value: string)
{
	if (node && value && node.classList)
	{
		value = value.trim();
		if (value)
			node.classList.add.apply(node.classList, value.split(' '));
	}
};

/**
 * @Deprecated
 * @param node
 * @param value
 */
NP.removeCssClass = function (node: HTMLElement, value: string)
{
	if (node && value && node.classList)
	{
		value = value.trim();
		if (value)
			node.classList.remove.apply(node.classList, value.split(' '));
	}
};

NP.hasCssClass = function (node: HTMLElement, value: string)
{
	if (node != null && value != null)
		return node.classList.contains(value.trim());
};

NP.isNodeVisible = function (node: HTMLElement)
{
	if (!node || node.parentNode == null || node.offsetParent == null)
		return false;
	if (NP.getCssStyle(node, "visibility") === "hidden" || NP.getCssStyle(node, "display") === "none")
		return false;
	let id = node.getAttribute("id"),
		 removeId = !id;
	if (!id)
	{
		id = "IsNodeVisibleId";
		node.setAttribute("id", id);
	}
	let isVisible = true;
	if (document.getElementById(id) == null)
		isVisible = false;
	if (removeId)
		node.removeAttribute("id");
	return isVisible;
};

NP.showNode = function (node: HTMLElement)
{
	NP.removeCssClass(node, "hide");
};

NP.hideNode = function (node: HTMLElement)
{
	NP.addCssClass(node, "hide");
};

NP.hideNodes = function (nodes: Array<HTMLElement>)
{
	nodes.forEach(node => NP.hideNode(node));
};

NP.showNodes = function (nodes: Array<HTMLElement>)
{
	nodes.forEach(node => NP.showNode(node));
};

NP.hide = function (items: any)
{
	if (items)
	{
		items = NP.toArray(items);
		for (let item of items)
		{
			if (item instanceof NP.Control)
				item.setIsVisible(false);
			else
				NP.hideNode(item);
		}
	}
};

NP.show = function (items: any)
{
	if (items)
	{
		items = NP.toArray(items);
		for (let item of items)
		{
			if (item instanceof NP.Control)
				item.setIsVisible(true);
			else
				NP.showNode(item);
		}
	}
};

NP.setIsVisible = function (items: any, value: boolean)
{
	if (value)
		NP.show(items);
	else
		NP.hide(items);
};


NP.getNodeRect = function (node: HTMLElement)
{
	if (!node.getBoundingClientRect)
		return node;
	let box = node.getBoundingClientRect();
	return {
		X: Math.round(box.left + NP.getDocumentScrollLeft() - (document.documentElement.clientLeft || document.body.clientLeft || 0)),
		Y: Math.round(box.top + NP.getDocumentScrollTop() - (document.documentElement.clientTop || document.body.clientTop || 0)),
		Width: box.width,
		Height: box.height
	};
};

NP.getMouseCoordinatesWithoutScroll = function (evt: MouseEvent)
{
	return {
		X: evt.clientX || null,
		Y: evt.clientY || null
	};
};

NP.getMouseCoordinates = function (evt: MouseEvent)
{
	//@ts-ignore
	evt = evt.touches && evt.touches[0] || evt.changedTouches && evt.changedTouches[0] || evt.originalEvent || evt;
	return {
		X: evt.pageX != null ? evt.pageX : (evt.clientX != null ? evt.clientX + NP.getDocumentScrollLeft() : null),
		Y: evt.pageY != null ? evt.pageY : (evt.clientY != null ? evt.clientY + NP.getDocumentScrollTop() : null)
	};
};


NP.createNode = function (parent: HTMLElement, className?: string, tagName?: string, beforeNode?: HTMLElement): HTMLElement
{
	if (!tagName)
		tagName = "div";
	let el = document.createElement(tagName);
	if (className)
		el.className = className;
	if (parent)
	{
		if (beforeNode)
			parent.insertBefore(el, beforeNode);
		else
			parent.appendChild(el);
	}
	return el;
};

NP.enableNode = function (node: HTMLElement, value: boolean)
{
	if (!node)
		return;
	if (value)
	{
		node.setAttribute("enabled", "enabled");
		node.removeAttribute("disabled");
	}
	else
	{
		node.setAttribute("disabled", "disabled");
		node.removeAttribute("enabled");
	}
};

NP.getMenuDropCoords = function (menu: any, nodeOrRect: any, dropPosition: any, invert?: boolean)
{
	const menuRoot = menu.getRoot();
	let isMenu;
	menuRoot.style.top =
		 menuRoot.style.left = '';
	if (menu instanceof NP.Menu)
	{
		isMenu = true;
		menu.setHeight(null);
	}
	if (!menu.getDroppedDown())
	{
		menuRoot.style.visibility = 'hidden';
		menu.getParentNode().appendChild(menuRoot);
	}
	NP.addCssClass(menuRoot, 'dropdown_vis-check');
	menu.removeClass('dropdown_hid');
	const menuRect = NP.getNodeRect(menuRoot);
	const documentWidth = document.documentElement.clientWidth;
	const documentHeight = document.documentElement.clientHeight;
	let result = {
		X: 0,
		Y: 0,
		Width: menuRect.Width,
		Height: menuRect.Height,
		DocumentWidth: documentWidth,
		DocumentHeight: documentHeight,
		Pos: dropPosition,
		IsChanged: false,
		Align: ''
	};
	if (!nodeOrRect)
		return result;
	const rect = nodeOrRect.X != null && nodeOrRect.Y != null && nodeOrRect.Width != null && nodeOrRect.Height != null ? nodeOrRect : NP.getNodeRect(nodeOrRect);
	if (!menu.getDroppedDown())
	{
		menu.getParentNode().removeChild(menuRoot);
		menuRoot.style.visibility = '';
	}
	if (menu.hasClass("dropdown_arrow-left"))
	{
		if (menuRect.Width > documentWidth - (rect.X + rect.Width + 8))
		{
			menu.setWidth(documentWidth - (rect.X + rect.Width + 8));
			menuRect.Width =
				 result.Width = documentWidth - (rect.X + rect.Width + 8);
			result.IsChanged = true;
		}
	}
	else
	{
		if (menuRect.Width > documentWidth)
		{
			menu.setWidth(documentWidth);
			menuRect.Width =
				 result.Width = documentWidth;
			result.IsChanged = true;
		}
	}
	if (menu.hasClass("dropdown_arrow-top"))
	{
		if (menuRect.Height > documentHeight - (rect.Y + rect.Height + 8))
		{
			menu.setHeight(documentHeight - (rect.Y + rect.Height + 8));
			menuRect.Height =
				 result.Height = documentHeight - (rect.Y + rect.Height + 8);
			result.IsChanged = true;
		}
	}
	else
	{
		if (menuRect.Height + (isMenu ? 48 : 0) > documentHeight)
		{
			menu.setHeight(documentHeight - (isMenu ? 48 : 0));
			menuRect.Height =
				 result.Height = documentHeight - (isMenu ? 48 : 0);
			result.IsChanged = true;
		}
	}

	switch (dropPosition)
	{
		case NP.LTRB.Left:
		case NP.LTRB.Right:
			if (menu.hasClass("dropdown_arrow-left") || menu.hasClass("dropdown_arrow-right"))
			{
				result.X = dropPosition === NP.LTRB.Left ? rect.X - menuRect.Width - 8 : rect.X + rect.Width + 8;
				result.Y = rect.Y - (menuRect.Height / 2 - rect.Height / 2);
			}
			else
			{
				result.X = dropPosition === NP.LTRB.Left ? rect.X - menuRect.Width : rect.X + rect.Width;
				result.Y = invert ? rect.Y + rect.Height - menuRect.Height : rect.Y;
			}
			result.Align = NP.VertAlign.Top;
			break;
		case NP.LTRB.Top:
		case NP.LTRB.Bottom:
			if (menu.hasClass("dropdown_arrow-top"))
			{
				result.X = rect.X - (menuRect.Width / 2 - rect.Width / 2);
				NP.removeCssClass(menuRoot, 'dropdown_arrow-top_align-left');
				if (result.X < 24)
				{
					result.X = 24;
					NP.addCssClass(menuRoot, 'dropdown_arrow-top_align-left');
				}
				result.Y = rect.Y + rect.Height + 8;
			}
			else
			{
				result.X = invert ? rect.X + rect.Width - menuRect.Width : rect.X;
				result.Y = dropPosition === NP.LTRB.Top ? rect.Y - menuRect.Height : rect.Y + rect.Height;
			}
			result.Align = NP.HorAlign.Left;
			break;
		case NP.LTRB.AboveTop:
		case NP.LTRB.AboveBottom:
			result.X = invert ? rect.X + rect.Width - menuRect.Width - 24 : rect.X + 24;
			result.Y = dropPosition === NP.LTRB.AboveTop ? rect.Y - menuRect.Height + rect.Height : rect.Y;
			result.Align = NP.HorAlign.Left;
			break;
	}
	if (!(result.Y > -1 && result.Y + menuRect.Height <= documentHeight))
	{ // не влезло по высоте
		switch (dropPosition)
		{
			case NP.LTRB.Left:
			case NP.LTRB.Right:
				if (rect.Y + rect.Height - menuRect.Height > -1)
				{ // влезает по нижней границе ноды
					result.Y = rect.Y + rect.Height - menuRect.Height;
					result.Align = NP.VertAlign.Bottom;
				}
				else if (rect.Y + Math.round((rect.Height - menuRect.Height) / 2) >= 0 && rect.Y + Math.round((rect.Height - menuRect.Height) / 2) + menuRect.Height <= documentHeight)
				{ // влезает по верхней границе ноды
					result.Y = rect.Y + Math.round((rect.Height - menuRect.Height) / 2);
					result.Align = NP.VertAlign.Middle;
				}
				else
					result.Y = documentHeight - menuRect.Height;
				break;
			case NP.LTRB.Top:
				if (rect.Y + rect.Height + menuRect.Height <= documentHeight)
				{ // влезает снизу
					result.Y = rect.Y + rect.Height;
					result.Pos = NP.LTRB.Bottom;
				}
				else
					result.Y = 0;
				break;
			case NP.LTRB.Bottom:
				if (rect.Y - menuRect.Height > -1)
				{ // влезает сверху
					result.Y = rect.Y - menuRect.Height;
					result.Pos = NP.LTRB.Top;
				}
				else
					result.Y = documentHeight - menuRect.Height;
				break;
			case NP.LTRB.AboveTop:
				if (rect.Y + rect.Height + menuRect.Height <= documentHeight)
				{ // влезает сверху
					result.Y = rect.Y;
					result.Pos = NP.LTRB.AboveBottom;
				}
				else
					result.Y = 0;
				break;
			case NP.LTRB.AboveBottom:
				if (rect.Y - menuRect.Height > -1)
				{ // влезает снизу
					result.Y = rect.Y + rect.Height - menuRect.Height;
					result.Pos = NP.LTRB.AboveTop;
				}
				else
					result.Y = documentHeight - menuRect.Height;
				break;
		}
		result.IsChanged = true;
	}
	if (!(result.X > -1 && result.X + menuRect.Width <= documentWidth))
	{
		switch (dropPosition)
		{
			case NP.LTRB.Top:
			case NP.LTRB.Bottom:
			case NP.LTRB.AboveTop:
			case NP.LTRB.AboveBottom:
				if (rect.X + rect.Width - menuRect.Width > -1)
				{ // влезает по правой границе ноды
					result.X = rect.X + rect.Width - menuRect.Width;
					result.Align = NP.HorAlign.Right;
				}
				else if (rect.X + Math.round((rect.Width - menuRect.Width) / 2) >= 0 && rect.X + Math.round((rect.Width - menuRect.Width) / 2) + menuRect.Width <= documentWidth)
				{ // влезает по левой границе ноды
					result.X = rect.X + Math.round((rect.Width - menuRect.Width) / 2);
					result.Align = NP.HorAlign.Center;
				}
				else
					result.X = documentWidth - menuRect.Width;
				break;
			case NP.LTRB.Left:
				if (rect.X + rect.Width + menuRect.Width <= documentWidth)
				{ // влезает справа
					result.X = rect.X + rect.Width;
					result.Pos = NP.LTRB.Right;
				}
				else
					result.X = 0;
				break;
			case NP.LTRB.Right:
				if (rect.X - menuRect.Width > -1)
				{ // влезает слева
					result.X = rect.X - menuRect.Width;
					result.Pos = NP.LTRB.Left;
				}
				else
					result.X = documentWidth - menuRect.Width;
				break;
		}
		result.IsChanged = true;
	}

	NP.removeCssClass(menuRoot, 'dropdown_vis-check');
	return result;
};

NP.closeDialogs = function ()
{
	let openedPanels = NP.DropPanel.OpenedPanels,
		 i = openedPanels.length;
	while (i--)
	{
		if (openedPanels[i] && openedPanels[i].isLive())
			openedPanels[i].hide();
	}
};

NP.closeDropPanels = function ()
{
	let openedPanels = NP.DropPanel.OpenedPanels,
		 i = openedPanels.length;
	while (i--)
	{
		if (openedPanels[i] && openedPanels[i].isLive())
		{
			if (openedPanels[i].getCloseOnWindowResize())
				openedPanels[i].hide();
			else
				openedPanels[i].updateSidePosition();
		}
	}
};

NP.showDropPanel = function (menu: any, node: any, dropPos: any, invert?: boolean, animate?: boolean)
{
	if (!menu.getIsVisible())
		menu.show(0, 0, true);
	let coords = NP.getMenuDropCoords(menu, node, dropPos, invert);
	if (animate || menu instanceof NP.Menu)
	{
		let originX, originY,
			 rect = node.X != null && node.Y != null && node.Width != null && node.Height != null ? node : NP.getNodeRect(node);
		if (dropPos == NP.LTRB.Left || dropPos == NP.LTRB.Right)
		{
			if (coords.X > rect.X + rect.Width)
				originX = coords.X - rect.X - rect.Width;
			else if (coords.X < rect.X + rect.Width)
				originX = rect.X - coords.X;
			else
				originX = 0;

			if (coords.Y > rect.Y)
				originY = coords.Y - rect.Y;
			else if (coords.Y < rect.Y)
				originY = rect.Y - coords.Y;
			else
				originY = 0;
		}
		else
		{
			if (coords.X > rect.X)
				originX = coords.X - rect.X;
			else if (coords.X < rect.X)
				originX = rect.X - coords.X;
			else
				originX = 0;

			if (coords.Y > rect.Y + rect.Height)
				originY = coords.Y - rect.Y - rect.Height;
			else if (coords.Y < rect.Y + rect.Height)
				originY = rect.Y - coords.Y + rect.Height;
			else
				originY = 0;
		}
		menu.setPositionAnimate(coords.X, coords.Y, originX, originY);
	}
	else
		menu.setPosition(coords.X, coords.Y);
	menu.updateSize();
	return coords;
};

NP.destroyS = function ()
{
	if (this._Dashboard && this._Dashboard.isLive())
		this._Dashboard.removeAllEvents(this);
	if (this._Source && this._Source.isLive())
		this._Source.removeAllEvents(this);
	delete this._Dashboard;
	delete this._Source;
	NP.Control.prototype.destroy.apply(this, arguments);
};

NP.downloadFile = function (url: string, timeout: number = 60000)
{
	let frame = document.createElement("iframe");
	frame.style.height =
		 frame.style.width = '0';
	frame.style.position = "absolute";
	//событие Onload у iframe не срабатывает
	setTimeout(function ()
	{
		document.body.removeChild(frame);
	}, timeout);
	frame.setAttribute("src", url);
	document.body.appendChild(frame);
};

NP.getFullscreenElement = function ()
{
	let doc = <any>document;
	return doc.fullscreenElement || doc.mozFullScreenElement || doc.webkitFullscreenElement || doc.msFullscreenElement;
};

NP.isFullscreen = function ()
{
	return !!NP.getFullscreenElement();
};

NP.getCorrectPluralForm = function (count: number)
{
	switch (NP.getCurrentCulture().Name)
	{
		case 'ru':
			return (count % 10 == 1 && count % 100 != 11 ?
					  0 :
					  count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 10 || count % 100 >= 20) ? 1 : 2
			);
		default:
			return (count != 1 ? 1 : 0);
	}
};



NP.getDocumentScrollLeft = function ()
{
	return window && window.pageXOffset || document.documentElement && document.documentElement.scrollLeft || document.body && document.body.scrollLeft || 0;
};

NP.getDocumentScrollTop = function ()
{
	return window && window.pageYOffset || document.documentElement && document.documentElement.scrollTop || document.body && document.body.scrollTop || 0;
};



NP.removeFromParent = function (node: HTMLElement)
{
	if (node && node.parentNode)
		node.parentNode.removeChild(node);
};


export interface ValueChangedEventArgs {
	Value: any
}

export interface EventArgs {
	Event: MouseEvent,
	Element: HTMLElement,
	Cancel: boolean,
	Item?: any
}

export interface EventKeyArgs {
	Element: HTMLElement,
	Event: KeyboardEvent
}


export interface Point {
	X?: number;
	Y?: number;
}



NP.LTRB = {
	Left: "Left",
	Top: "Top",
	AboveTop: "AboveTop",
	Right: "Right",
	AboveBottom: "AboveBottom",
	Bottom: "Bottom"
};

NP.Key = {
	Backspace: 8,
	Tab: 9,
	Enter: 13,
	Esc: 27,
	Space: 32,
	End: 35,
	Home: 36,
	Left: 37,
	Up: 38,
	Right: 39,
	Down: 40,
	Insert: 45,
	Del: 46,
	A: 65,
	C: 67,
	I: 73,
	O: 79,
	R: 82,
	S: 83,
	V: 86,
	X: 88,
	Z: 90,
	Add: 107,
	Substract: 109,
	F2: 113,
	F5: 116,
	F12: 123
};

NP.HorAlign = {
	Left: "Left",
	Center: "Center",
	Right: "Right",
	Justify: "Justify"
};

NP.VertAlign = {
	Top: "Top",
	Middle: "Middle",
	Bottom: "Bottom"
};


NP.escapeHTML = function (str: string)
{
	if (!str)
		return str;
	return S(str).escapeHTML().s;
};


NP.getSchemaKey = function (key: string)
{
	return parseInt(key.split("$")[0]);
};

NP.replaceAll = function (str: string, s1: string, s2: string)
{
	if (!str)
		return str;
	return S(str).replaceAll(s1, s2).s;
};


NP.initHotKeys = function ()
{
	document.body.addEventListener('keydown', function (evt)
	{
		switch (evt.keyCode)
		{
			case NP.Key.Esc:
				NP.DropPanel.closeNonDialogPanels();
				// NP.getLastOpenedDialog() && NP.getLastOpenedDialog()._onCancelButtonClick();
				break;
		}
	}, false);
};

export default NP as any;
